import { api } from '../../../lib/api';
import { snakeCaseKeys } from '../../../shared/helpers';

const prepareBroadcastData = values => {
  const { audiences, audienceIds, ...rest } = values;

  const data = { ...rest };

  if (audienceIds !== undefined) {
    data.audienceIds = audienceIds;
  } else if (audiences && audiences.length > 0) {
    data.audienceIds = audiences.map(a => a.value);
  }

  return data;
};

export const createBroadcastMessage = values =>
  api({
    method: 'post',
    url: '/api/client_admin/broadcast_messages/',
    data: {
      broadcast_message: snakeCaseKeys(prepareBroadcastData(values)),
    },
  });

export const updateBroadcastMessage = values =>
  api({
    method: 'put',
    url: `/api/client_admin/broadcast_messages/${values.uuid}`,
    data: {
      broadcast_message: snakeCaseKeys(prepareBroadcastData(values)),
    },
  });

export const deleteBroadcastMessage = ({ id }) => {
  return api({
    method: 'delete',
    url: `/api/client_admin/broadcast_messages/${id}`,
  });
};

export const copyBroadcastMessage = ({ id }) => {
  return api({
    method: 'post',
    url: `/api/client_admin/broadcast_messages/${id}/copy`,
  });
};

export const sendBroadcastMessage = values => {
  let broadcastMessageData;
  const {
    uuid,
    subject,
    smsBody,
    emailBody,
    broadcastType,
    campaignUuid,
    scheduledDate,
    scheduledHour,
  } = values;

  // Only pass scheduledDate and scheduledHour - let backend handle
  // timezone conversion using the board's timezone
  const scheduleParams =
    scheduledDate && scheduledHour !== undefined && scheduledHour !== null
      ? { scheduledDate, scheduledHour }
      : {};

  switch (values.broadcastType) {
    case 'email':
      broadcastMessageData = snakeCaseKeys({
        subject,
        emailBody,
        broadcastType,
        campaignUuid,
        ...scheduleParams,
      });
      break;
    case 'sms':
      broadcastMessageData = snakeCaseKeys({
        smsBody,
        broadcastType,
        campaignUuid,
        ...scheduleParams,
      });
      break;
    default:
      broadcastMessageData = snakeCaseKeys({
        subject,
        smsBody,
        emailBody,
        broadcastType,
        campaignUuid,
        ...scheduleParams,
      });
      break;
  }

  return api({
    method: 'post',
    url: `/api/client_admin/broadcast_messages/${uuid}/finalize`,
    data: { broadcast_message: broadcastMessageData },
  });
};

export const retry = ({ id }) => {
  return api({
    method: 'post',
    url: `/api/client_admin/broadcast_messages/${id}/retry`,
  });
};

export const sendTest = ({ id, asUserUuid }) => {
  return api({
    method: 'post',
    url: `/api/client_admin/broadcast_messages/${id}/send_test`,
    data: asUserUuid ? { as_user_uuid: asUserUuid } : {},
  });
};

export const cancelScheduledBroadcast = ({ id }) => {
  return api({
    method: 'post',
    url: `/api/client_admin/broadcast_messages/${id}/cancel`,
  });
};

export const sendScheduledNow = ({ id }) => {
  return api({
    method: 'post',
    url: `/api/client_admin/broadcast_messages/${id}/send_now`,
  });
};

export const updateDraftDate = ({ id, draftDate }) => {
  return api({
    method: 'put',
    url: `/api/client_admin/broadcast_messages/${id}`,
    data: {
      broadcast_message: { draft_date: draftDate },
    },
  });
};

export const rescheduleBroadcast = ({ id, scheduledDate, scheduledHour }) => {
  return api({
    method: 'post',
    url: `/api/client_admin/broadcast_messages/${id}/reschedule`,
    data: {
      broadcast_message: {
        scheduled_date: scheduledDate,
        scheduled_hour: scheduledHour,
      },
    },
  });
};
